import { CurrentPanelistInfoResponse } from "~/api/generated/usabilityhub-components"

export const ONBOARDING_PHASE = "onboarding"
export const BOOSTING_PHASE = "boosting"
export type Phase = typeof ONBOARDING_PHASE | typeof BOOSTING_PHASE

export type BoostingStepKey = "linkedin_verification" | "profile"
export type BoostingStatus = "incomplete" | "complete" | "dismissed"
export const BOOSTING_STEPS: BoostingStepKey[] = [
  "linkedin_verification",
  "profile",
]

export type OnboardingStepKey =
  | "agreement"
  | "basic_details"
  | "phone_number_verification"
  | "notification_preferences"
  | "practice_test"
export type OnboardingStatus =
  | "incomplete"
  | "complete"
  | "rejected"
  | "not_required"
export const ONBOARDING_STEPS: OnboardingStepKey[] = ["practice_test"]

export const PRACTICE_TEST_STATUS_MAP: {
  [s in CurrentPanelistInfoResponse["practice_test_state"]]:
    | "incomplete"
    | "complete"
    | "rejected"
    | "not_required"
} = {
  not_required: "not_required",
  not_started: "incomplete",
  in_progress: "incomplete",
  // We mark the task as "complete" even if the panelist's response is still pending manual review
  awaiting_review: "complete",
  passed: "complete",
  auto_review_fail: "rejected",
  manual_qa_fail: "rejected",
}
